import { useState } from "react";
import "@/App.css";
import { Header, Footer } from "./components/Chrome";
import { Hero } from "./components/Hero";
import { Results } from "./components/Results";
import { Bonus } from "./components/Bonus";
import { ChapterCover } from "./components/ChapterCover";
import { Pillars } from "./components/Pillars";
import { Tasks } from "./components/Tasks";
import { Schedule } from "./components/Schedule";
import { Conclusion } from "./components/Conclusion";
import { OneMoreThing } from "./components/OneMoreThing";
import { Lightbox } from "./components/Lightbox";

function App() {
  const [zoom, setZoom] = useState(null);
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <ChapterCover id="results" part="01" title="直接效應" value="每月多 NT$24–111 萬" note="透過 LINE@、人客多專案、電話訂房直接成交｜與去年同期相比" color="var(--orange)" />
        <Results onZoom={setZoom} />
        <ChapterCover id="bonus" part="02" title="外溢效益" value="每月再多 NT$82–392 萬" note="團建、訂房網站、Google、UGC 帶來的額外效益｜與去年同期相比" color="var(--teal-d)" />
        <Bonus />
        <Pillars />
        <Tasks onZoom={setZoom} />
        <Schedule />
        <Conclusion />
        <OneMoreThing />
      </main>
      <Footer />
      <Lightbox image={zoom} onClose={() => setZoom(null)} />
    </div>
  );
}

export default App;
